import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ConfigAssetLoaderService,
  InterceptorSkipHeader,
} from '@icullen/api/shared';
import { DocumentSelectionGroup } from '../model/document-selection-group.model';
import { DocumentSelectionList } from '../model/document-selection-list.model';

@Injectable({
  providedIn: 'root',
})
export class DocumentApiService {
  DOCUMENT_API_BASE_URL: string;
  FAVORITES_API_BASE_URL: string;

  constructor(
    private httpClient: HttpClient,
    //@Inject('apiBaseUrl') private apiBaseUrl: string,
    private configService: ConfigAssetLoaderService
  ) {
    this.DOCUMENT_API_BASE_URL =
      configService.getConfig().apiBaseUrl + 'site/documents/';
  }

  getDocumentByUniqueNumber(
    uniqueNumber: string,
    version?: string
  ): Observable<any> {
    if (version) {
      return this.httpClient.get(
        this.DOCUMENT_API_BASE_URL +
          'detail/' +
          uniqueNumber +
          '?version=' +
          version
      );
    }
    return this.httpClient.get(
      this.DOCUMENT_API_BASE_URL + 'detail/' + uniqueNumber
    );
  }

  getDocumentByToken(token: string): Observable<any> {
    return this.httpClient.get(this.DOCUMENT_API_BASE_URL + 'preview/' + token);
  }

  getTableViewByNameAndUniqueNumber(
    uniqueNumber: string,
    viewId: string
  ): Observable<any> {
    return this.httpClient.get(
      this.DOCUMENT_API_BASE_URL + 'view/' + uniqueNumber + '/' + viewId
    );
  }

  getSimilarDocuments(uniqueNumber: string): Observable<any> {
    return this.httpClient.get(
      this.DOCUMENT_API_BASE_URL + 'similarto/' + uniqueNumber,
      InterceptorSkipHeader
    );
  }

  getOverviewDocument(relatedpath: string): Observable<any> {
    return this.httpClient.get(
      this.DOCUMENT_API_BASE_URL +
        'overview-document?relatedpath=' +
        relatedpath
    );
  }

  getDocumentSelectionGroup(
    service: string
  ): Observable<DocumentSelectionGroup[]> {
    return this.httpClient.get<DocumentSelectionGroup[]>(
      this.DOCUMENT_API_BASE_URL + 'selections/groups/' + service
    );
  }

  getDocumentSelectionList(
    service: string,
    documentType: string,
    group: string,
    subgroup: string
  ): Observable<DocumentSelectionList> {
    return this.httpClient.get<DocumentSelectionList>(
      this.DOCUMENT_API_BASE_URL +
        'selections/list/' +
        service +
        '/' +
        documentType +
        '/' +
        group +
        '/' +
        subgroup
    );
  }
}
